import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated() && auth.isAccessTokenValid()) {
    return true;
  }

  if (auth.hasRefreshableSession()) {
    return from(auth.refreshSession()).pipe(
      map((ok) => (ok ? true : router.createUrlTree(['/connexion']))),
    );
  }

  return of(router.createUrlTree(['/connexion']));
};
